import React from 'react';
import { PrivacyPolicyContainer } from '../PrivacyPolicy/PrivacyStyles.styles';

const Payment = () => {
  return (
    <PrivacyPolicyContainer>
      <h3>Payment Terms</h3>

      <p>
        Prices for courses, subscriptions, products, and services are displayed
        or communicated in connection with the applicable purchase or service.
        Payments made through the Yoda Safety Services platform are processed by
        Stripe or another authorized third-party payment processor.
      </p>

      <p>
        By submitting a payment through the platform, you agree to provide
        accurate and complete information and to comply with the applicable
        payment processor&apos;s terms and policies. Yoda Safety Services does
        not store credit card numbers.
      </p>

      <p>
        Certain products, custom documentation, workplace safety services, or
        other purchases may be arranged directly with Yoda Safety Services and
        may be subject to additional payment terms provided through an invoice,
        proposal, agreement, or other applicable documentation.
      </p>

      <h4>Course Purchases</h4>

      <p>
        Course purchases provide access to the applicable training for the user
        or users to whom the course is assigned, subject to these Terms &
        Conditions and any applicable course requirements.
      </p>

      <p>
        Where a company or organization purchases training for employees or
        other users, the purchaser is responsible for selecting the appropriate
        courses and assigning them to the intended users.
      </p>

      <h4>Subscriptions</h4>

      <p>
        Certain platform features or services may be offered on a subscription
        basis. The applicable price, billing period, and included services will
        be communicated in connection with the subscription.
      </p>

      <p>
        Subscription access may be restricted or discontinued if required
        payments are not successfully completed, subject to any applicable
        agreement and applicable law.
      </p>

      <h4>Refund Policy</h4>

      <p>
        Unless otherwise stated at the time of purchase or required by
        applicable law, purchases of online courses are non-refundable once
        access to the purchased training has been provided.
      </p>

      <p>
        Refund requests relating to duplicate charges, technical errors,
        incorrect transactions, or other exceptional circumstances may be
        reviewed on a case-by-case basis. Additional refund or cancellation
        terms may apply to subscriptions, products, custom documentation, or
        other services where specified in an applicable agreement, proposal,
        invoice, or purchase terms.
      </p>

      <p>
        To request assistance regarding a payment or refund, please contact us
        at{' '}
        <a href="mailto:yodasafetyservices1@outlook.com">
          yodasafetyservices1@outlook.com
        </a>
        .
      </p>

      <h4>Taxes</h4>

      <p>
        Applicable taxes may be added to purchases as required by law. Where
        taxes are collected through the online checkout, the applicable amount
        will be displayed as part of the transaction. Taxes applicable to
        purchases arranged outside the platform may be identified on the
        applicable invoice, proposal, or other purchase documentation.
      </p>

      <h4>Currency and Third-Party Fees</h4>

      <p>
        Unless otherwise stated, prices and transactions are in Canadian dollars
        (CAD). Your financial institution or payment provider may charge
        additional fees, including currency conversion, foreign transaction, or
        other processing fees. Any such third-party fees are determined by the
        applicable provider and are not charged by Yoda Safety Services.
      </p>

      <h4>Failed, Reversed, or Disputed Payments</h4>

      <p>
        If a required payment fails, is reversed, or remains unpaid, access to
        the applicable course, subscription, account feature, or service may be
        restricted or suspended until the payment issue is resolved.
      </p>

      <p>
        If a payment is disputed or subject to a chargeback, Yoda Safety
        Services may temporarily restrict access associated with the disputed
        purchase while the matter is reviewed. We may provide relevant
        transaction records to the applicable payment processor or financial
        institution as reasonably necessary to respond to the dispute.
      </p>

      <p>
        Nothing in this section limits any refund, cancellation, or other
        consumer right that cannot be excluded under applicable law.
      </p>
    </PrivacyPolicyContainer>
  );
};

export default Payment;
